// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"581f9403","161":"d7d84f9e","247":"ed1c0d93","422":"056a1bec","627":"5bab7cb2","867":"40583bf9","923":"8cd692c9","938":"c7d94c6e","986":"3c5e6470"}[chunkId] + ".chunk.js";
};